import { render } from "./range-origin.vue?vue&type=template&id=bc45baee"
import script from "./range-origin.vue?vue&type=script&lang=js"
export * from "./range-origin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__